import { AppAccountSettingRepository } from "@/domain/repository/app-account-setting-repository";

export class IsExistAuthorizedTokenUsecase {
  constructor(private readonly appAccountSettingRepo: AppAccountSettingRepository) {}

  async execute(): Promise<boolean> {
    return this.appAccountSettingRepo.isExistAuthorizedToken();
  }
}
